<script>
  import Button from "@components/Button";
  import { _ } from "@services/i18n";
  import minimize from "@services/minimize";
  import { showUserSheet } from "@stores/sheets";
  import { FADE_DURATION } from "../consts";

  let working = false;

  /**
   * Sign out user from firebase
   */
  async function signOut() {
    working = true;
    const { default: firebaseClient } = await import(
      /* webpackChunkName: "firebase" */
      "@services/firebase"
    );
    const { auth } = await firebaseClient();
    await auth.signOut();
    working = false;
    showUserSheet.update(() => false);
    minimize();
    setTimeout(() => window.location.reload(), FADE_DURATION);
  }
</script>

<Button on:click={signOut} {working}>
  {$_("components.sign_out_button.text", { default: "Sign out" })}
</Button>
